import getters from './getters';
import mutations from './mutations';
import state from './state';
export const AppModule = {
    state,
    getters,
    mutations
};
